<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">   
      <div class="mt-5"></div>
      <job-group-history-table />
    </b-container>
  </div>
</template>

<script>
import JobGroupHistoryTable from "@/views/Tables/JobGroupHistoryTable";

export default {
components: {
    JobGroupHistoryTable
}
};
</script>

<style>

</style>